<template src="./ModalMessageZaloComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {ref, watch, reactive} from "vue";
import LabelPriority from "@/components/labels/label-priority/LabelPriority.vue";
import LabelStatus from "@/components/labels/label-status/LabelStatus.vue";
import IconEye from "@/components/icons/IconEye.vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import InputTextareaNormal from "@/components/inputs/input-textarea/normal/InputTextareaNormal.vue";
import IconEdit from "@/components/icons/IconEdit.vue";
import IconTrash from "@/components/icons/IconTrash.vue";
import InputCheckboxOne from "@/components/inputs/input-checkbox/normal/InputCheckboxNormal.vue";
import {useAccountStore} from "@/stores/account.js";
import PaginateComponent from "@/components/paginate/PaginateComponent.vue";
import CommonService from "@/services/common.service";
import {useSettingFormatFileStore} from "@/stores/settingFormatFile.js";
export default {
  name: 'ModalMessageZaloComponent',
  components: {
    PaginateComponent,
    InputCheckboxOne,
    IconTrash, IconEdit,
    InputTextareaNormal,
    ButtonAddComponent,
    IconEye,
    LabelStatus,
    LabelPriority, ButtonSearchComponent, SelectNormal, InputTextNormal, BreadcrumbComponent, IconHome,
  },
  props: {
    showModal: {
      type: Boolean,
      required: false,
      default: () => false
    },
    eventClickShowModal: {
      type: Boolean,
      required: false,
      default: () => false
    },
    message: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  emits: ['showModal'],
  setup(props, { emit }) {
    const errors = ref(true)
    const dataModal = ref({
      file_name: {
        id: 'file_name',
        label: 'Tên file',
        placeholder: 'Tên file',
        value: '',
        required: false,
        disable: false,
      },
      table_use: {
        id: 'table_use',
        label: 'Nơi sử dụng',
        placeholder: 'Nơi sử dụng',
        value: '',
        required: false,
        disable: true,
      },
      name: {
        id: 'name',
        label: 'Tên cài đặt',
        placeholder: 'Tên cài đặt',
        value: '',
        required: false,
        disable: false,
        options: []
      },
      type: {
        id: 'type',
        label: 'Kiểu File',
        placeholder: 'Kiểu File',
        value: '',
        required: false,
        disable: true,
      },
    })
    const clickShowModal = ref(false)
    const accountStore = useAccountStore()
    const messageDetail = reactive({
      name: {
        label: 'Tên tin nhắn',
        value: ''
      },
      description: {
        label: 'Mô tả',
        value: '',
      },
      content: {
        label: 'Mẫu tin nhắn',
        id: 'content',
        placeholder: 'Mẫu tin nhắn',
        value: '',
        error: '',
        isError: false,
        disabled: true
      },
      variables:{
        label: 'Giá trị cần lưu',
        value: []
      },
    })
    const avatar = ref('')
    const settingFormatFileStore = useSettingFormatFileStore()

    watch(() => props.eventClickShowModal, (eventClickShowModal) => {
      clickShowModal.value = eventClickShowModal
      console.log(props.message)
      if(props.message) {
        messageDetail.name.value = props.message.name ?? ''
        messageDetail.description.value = props.message.description ?? ''
        messageDetail.content.value = props.message.content ?? ''
        messageDetail.variables.value = props.message.variables
        messageDetail.variables.value.forEach((item) => {
          if(item.key === 'app_name') {
            item.value = 'INVOICEX'
            item.disabled = true
          }
          if(['register_link', 'invite_link', 'delivery_code', 'total_items', 'total_amount', 'delivery_link', 'receiver_name', 'delivery_date', 'sender_name', 'hotline'].includes(item.key)) {
            item.disabled = true
            item.placeholder = 'Giá trị sẽ được tự động thay vào vào khi sử dụng đối với từng mục đích'
          }
        })
      }
      emit('showModal', true)
    })


    watch(() => settingFormatFileStore.settingFormat, (newListSettingFormat) => {
      newListSettingFormat.forEach((item) => {
        dataModal.value.name.options.push({
          name: item.name,
          value: item.id,
        })
      })
    });

    watch(() => dataModal.value.name.value, (newSetting) => {
      const settingSelected = settingFormatFileStore.settingFormat.find(setting => newSetting === setting.id)
      dataModal.value.type.value = CommonService.compareTypeFileLabel(settingSelected.type ?? 0)
    });

    function onChange(value, name) {
      dataModal.value[name].value = value;
    }

    return {
      dataModal,
      messageDetail,
      avatar,
      onChange,
      CommonService
    }
  },
}
</script>
<style lang="scss">
#modalExport {
  .modal-content {
    background: #ffffff;
  }

  .modal-body {
    .select-form, .input-number {
      width: 172px;
    }
  }
  .modal-header {
    border-bottom: 1px solid #d9dee3;
  }
}
@media (min-width: 1200px) {
  .modal-xxl {
    max-width: 1540px;
  }
}
</style>